//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        order: String,
        opts: {
            type: Array,
            default () {
                return [
                    {
                        text: '默认排序',
                        value: ''
                    },
                    {
                        text: '上新优先',
                        value: 'new_arrival'
                    }
                ]
            }
        }
    },
    methods: {
        onSelect (e) {
            const { value, text } = e.currentTarget.dataset
            this.$emit('change', {
                value,
                text
            })
        }
    }
}
